import React from "react";
import { Button, Modal, Typography } from "@arco-design/web-react";
import { IconDelete } from "@arco-design/web-react/icon";

const { Text } = Typography;

// A "Danger zone" box for irreversible actions at the bottom of an editor.
// onConfirm runs after the user confirms in a dialog listing `notes`
// ({warn, text}: what the action means, warnings highlighted).
export default function DangerZone({ description, buttonLabel, confirmTitle, notes, onConfirm, loading }) {
    const confirm = () => {
        Modal.confirm({
            title: confirmTitle,
            content: (
                <ul style={{ paddingLeft: 18, margin: 0 }}>
                    {(notes || []).map((n) => (
                        <li key={n.text} style={{ marginBottom: 6, color: n.warn ? "rgb(var(--orange-7))" : undefined, fontWeight: n.warn ? 500 : 400 }}>{n.text}</li>
                    ))}
                </ul>
            ),
            okText: buttonLabel,
            okButtonProps: { status: "danger" },
            cancelText: "Cancel",
            onOk: onConfirm,
        });
    };

    return (
        <div style={{ marginTop: 24, border: "1px solid rgb(var(--red-3))", borderRadius: 8, padding: "12px 16px", background: "var(--color-bg-2)" }}>
            <div style={{ fontWeight: 600, color: "rgb(var(--red-6))", marginBottom: 4 }}>Danger zone</div>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, justifyContent: "space-between" }}>
                <Text type="secondary" style={{ fontSize: 13, flex: "1 1 260px" }}>{description}</Text>
                <Button status="danger" icon={<IconDelete />} loading={loading} onClick={confirm}>{buttonLabel}</Button>
            </div>
        </div>
    );
}
